import { jsx as _jsx } from "react/jsx-runtime";
import styled from "../../../client-utils/styled/styled.js";
import shouldForwardProp from "../../../client-utils/styled/shouldForwardProp.util.js";
import insertIf from "../../../common-utils/object/objectInsertIf.util.js";
import { QUADRUPLE } from "../../../constants/numbers.consts.js";
import { NAVIGATION_RAIL_DRAWERWIDTH } from "../../../constants/navigationRail.consts.js";
import Icon from "../../../components/atoms/Icon/index.js";
import Button from "../../../components/atoms/Button/index.js";
const coreComponentName = "SdbAppBarAppSwitcherIconButton";
const ButtomAtom = (props) => _jsx(Button, { disableElevation: true, ...props });
export const AppSwitcherButton = styled(ButtomAtom, {
    name: coreComponentName,
    slot: "Root",
    shouldForwardProp: shouldForwardProp("active"),
})(({ theme, active }) => ({
    width: NAVIGATION_RAIL_DRAWERWIDTH,
    borderRadius: 0,
    borderBottomRightRadius: theme.spacing(QUADRUPLE),
    color: theme.vars.palette.common.white,
    ...theme.mixins.toolbar,
    ...(active && {
        color: theme.vars.palette.common.black,
        background: theme.vars.palette.secondary.container,
        ...theme.applyStyles("dark", {
            background: theme.vars.palette.secondary.main,
        }),
    }),
}));
export const AppSwitcherIcon = styled(Icon, {
    name: coreComponentName,
    slot: "Icon",
    shouldForwardProp: shouldForwardProp("mobileIcon", "hasOneApplication"),
})(({ theme, mobileIcon, hasOneApplication }) => ({
    display: mobileIcon ? "inline-block" : "none",
    [`${theme.breakpoints.up("expanded")}`]: {
        display: mobileIcon ? "none" : "inline-block",
        ...insertIf(!!hasOneApplication, { transform: "scale(2.5)" }),
    },
}));
